import { coreAgent } from "../../app/api/agent";
import { CinsFinsEligibilityCriterionDto } from "./dtos/CinsFinsEligibilityCriterionDto";

export const getCinsFinsElibilityCriteraRequest = () =>
  coreAgent.getRequest<CinsFinsEligibilityCriterionDto[]>(
    "/CinsFinsEligibilityCriteria"
  );
